import { Button } from "design-system/atoms/Button"
import { Form, FormField, FormItem, FormMessage } from "design-system/organisms/Form"
import { UploadInput } from "design-system/organisms/UploadInput"
import { getErrorTranslations } from "lib/i18n"
import { useDownloadCustomersTemplateMutation } from "modules/customers/hooks/useDownloadCustomersTemplateMutation"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { IMPORTER_ACCEPTED_MIME_TYPES } from "schema"
import { toast } from "sonner"

type Props = {
  fileForm: UseFormReturn<FieldValues>
}

export function ImportFileField({ fileForm }: Props) {
  const { t } = useTranslation()

  const { mutateAsync: downloadCustomersTemplate, isPending: isDownloading } =
    useDownloadCustomersTemplateMutation()

  function onDownload(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault()

    const promise = downloadCustomersTemplate()

    toast.promise(promise, {
      loading: t("customers.imports.exportInProgress"),
      success: t("customers.imports.exportSuccess"),
    })
  }

  return (
    <Form
      {...(fileForm as unknown as React.ComponentProps<typeof Form>)}
      errorTranslations={getErrorTranslations()}
    >
      <FormField
        control={fileForm.control}
        name="file"
        render={() => (
          <FormItem>
            <UploadInput
              register={fileForm.register("file")}
              fileName={fileForm.watch("file")?.[0]?.name}
              placeholder={t("shared.uploadInput.selectFile")}
              accept={IMPORTER_ACCEPTED_MIME_TYPES.join(",")}
            />
            <FormMessage />
          </FormItem>
        )}
      />
      <Button
        variant="secondary"
        size="sm"
        onClick={onDownload}
        disabled={isDownloading}
        className="w-fit"
      >
        {t("customers.imports.upload.exportTemplate")}
      </Button>
    </Form>
  )
}
